import { createAction } from '@reduxjs/toolkit';

export const GetImageryProvidersStartAction = createAction('imagery/GetImageryProvidersStartAction');
export const GetImageryProvidersSuccessAction = createAction<IImageryProvider[]>('imagery/GetImageryProvidersSuccessAction');
export const GetImageryProvidersFailedAction = createAction('imagery/GetImageryProvidersFailedAction');

// reset all imagery coverage state to false
export const ResetImageryCoverageAction = createAction('imagery/ResetImageryCoverageAction');
// set the imagery checked state to true or false
// setting this in redux so we can use it in different components
export const SetImageryCheckedAction = createAction<boolean>('imagery/SetImageryCheckedAction');

export const GetImageryCoverageStartAction = createAction('imagery/GetImageryCoverageStartAction');
export const GetImageryCoverageSuccessAction = createAction<boolean>('imagery/GetImageryCoverageSuccessAction');
export const GetImageryCoverageFailedAction = createAction('imagery/GetImageryCoverageFailedAction');

export const ToggleImageryProcessingAction = createAction('imagery/ToggleImageryProcessingAction');

export const CreateImageryRequestStartAction = createAction('imagery/CreateImageryRequestStartAction');
export const CreateImageryRequestSuccessAction = createAction('imagery/CreateImageryRequestSuccessAction');
export const CreateImageryRequestFailedAction = createAction('imagery/CreateImageryRequestFailedAction');
